import moment from 'moment/moment';
import * as XLSX from 'xlsx';
import cronstrue from "cronstrue";

export function downloadXlsx(shipments: any): void {
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(shipments);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, `Validation Dashboard`);
  XLSX.writeFile(wb, `Validation_Dashboard_${moment().format('MM-DD-YYYY-THH_mm_ss')}.xlsx`);
}

export function decodeBase64(base64: string): string {
  return atob(base64);
}

export function formatCronReadable(cronExpression: string): string {
  try {
    return cronstrue.toString(cronExpression, { use24HourTimeFormat: true });
  } catch (error) {
    return error;
  }
}

export function base64ToBlob(base64: string, mimeType: string = 'application/pdf'): Blob {

  const byteString = atob(base64);

  const byteArray = new Uint8Array(byteString.length);

  for (let i = 0; i < byteString.length; i++) {
    byteArray[i] = byteString.charCodeAt(i);
  }

  return new Blob([byteArray], { type: mimeType });
}

